module.exports = __webpack_public_path__ + "static/media/Avenir-Book.0bd4deb0.otf";